// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "NewbuildingPromoModalContainer" + "." + "b650fc6dd0452e8806dd" + ".css";
};